<template>
  <div class="filters-container">

    <div class="filters-header">
      <div>
        <div class="filters-eyebrow">
          Поиск
        </div>

        <h3 class="filters-title">
          Фильтры
        </h3>
      </div>
    </div>


    <!-- =====================================================
         REMOTE
    ====================================================== -->

    <section class="filter-group">

      <p class="filter-label">
        Удалёнка
      </p>

      <label class="checkbox-option">

        <input
          type="radio"
          name="remote"
          value="all"
          v-model="selectedRemote"
        />

        <span class="control-indicator radio-indicator"></span>

        <span class="option-text">
          Все вакансии
        </span>

      </label>


      <label class="checkbox-option">

        <input
          type="radio"
          name="remote"
          value="remote-only"
          v-model="selectedRemote"
        />

        <span class="control-indicator radio-indicator"></span>

        <span class="option-text">
          Только удалёнка
        </span>

      </label>

    </section>


    <div class="filter-divider"></div>


    <!-- =====================================================
         SPECIFICS
    ====================================================== -->

    <section class="filter-group">

      <p class="filter-label">
        Специфика
      </p>

      <div class="specifics-list">

        <label
          v-for="spec in specificsOptions"
          :key="spec.id"
          class="checkbox-option specificity"
        >

          <input
            type="checkbox"
            :value="spec.id"
            v-model="selectedSpecifics"
          />

          <span class="control-indicator checkbox-indicator">

            <svg
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M4 8.2L6.7 10.8L12 5.5"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

          </span>

          <span class="option-text">
            {{ spec.name }}
          </span>

        </label>

      </div>

    </section>


    <div class="filter-divider"></div>


    <!-- =====================================================
         REGION
    ====================================================== -->

    <section class="filter-group last">

      <p class="filter-label">
        Регион
      </p>


      <label class="checkbox-option">

        <input
          type="radio"
          name="region"
          value="all"
          v-model="selectedRegion"
        />

        <span class="control-indicator radio-indicator"></span>

        <span class="option-text">
          Показывать все вакансии
        </span>

      </label>


      <label class="checkbox-option">

        <input
          type="radio"
          name="region"
          value="local"
          v-model="selectedRegion"
        />

        <span class="control-indicator radio-indicator"></span>

        <span class="option-text">
          Только из моего региона
        </span>

      </label>

    </section>

  </div>
</template>


<script setup>

import {
  ref,
  onMounted,
  watch
} from "vue";

import SpecificsService
  from "../utils/SpecificsService.js";


const emit =
  defineEmits([
    "filtersChanged"
  ]);


const selectedRegion =
  ref("all");

const selectedRemote =
  ref("all");

const selectedSpecifics =
  ref([]);

const specificsOptions =
  ref([]);


watch(
  [
    selectedRemote,
    selectedSpecifics,
    selectedRegion
  ],
  () => {

    emit(
      "filtersChanged",
      {
        remote:
          selectedRemote.value,

        specifics:
          selectedSpecifics.value,

        region:
          selectedRegion.value
      }
    );

  },
  {
    deep: true
  }
);


onMounted(() => {

  specificsOptions.value =
    SpecificsService.getSpecifics();

});


defineExpose({
  selectedRemote,
  selectedSpecifics,
  selectedRegion
});

</script>


<style scoped>

/* ============================================================
   ROOT
============================================================ */

.filters-container {
  width: 250px;

  box-sizing: border-box;

  padding:
    22px
    20px;

  background:
    #ffffff;

  border:
    1px solid
    rgba(25, 40, 60, 0.08);

  border-radius: 20px;

  box-shadow:
    0
    14px
    38px
    rgba(15, 23, 42, 0.045);

  font-family:
    "Eastman-Regular",
    sans-serif;
}


/* ============================================================
   HEADER
============================================================ */

.filters-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 22px;
}


.filters-eyebrow {
  margin-bottom: 4px;

  color: #9a9fa7;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 7px;

  letter-spacing: 0.08em;

  text-transform: uppercase;
}


.filters-title {
  margin: 0;

  color: #2f343b;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size: 14px;

  line-height: 1.2;

  letter-spacing: -0.15px;
}


/* ============================================================
   GROUP
============================================================ */

.filter-group {
  margin: 0;
}


.filter-group.last {
  margin-bottom: 0;
}


.filter-label {
  margin:
    0
    0
    13px;

  color: #626973;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 10px;

  line-height: 1.2;
}


/* ============================================================
   DIVIDER
============================================================ */

.filter-divider {
  width: 100%;
  height: 1px;

  margin:
    18px
    0;

  background:
    rgba(25, 40, 60, 0.055);
}


/* ============================================================
   OPTION
============================================================ */

.checkbox-option {
  position: relative;

  width: 100%;

  display: flex;
  align-items: flex-start;

  gap: 8px;

  box-sizing: border-box;

  margin-bottom: 9px;

  padding:
    2px
    0;

  color: #575e67;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size: 10px;

  line-height: 1.42;

  cursor: pointer;

  user-select: none;

  transition:
    color 0.18s ease;
}


.checkbox-option:last-child {
  margin-bottom: 0;
}


.option-text {
  min-width: 0;

  flex: 1;
}


/* ============================================================
   HIDDEN NATIVE INPUT
============================================================ */

.checkbox-option input {
  position: absolute;

  width: 1px;
  height: 1px;

  overflow: hidden;

  opacity: 0;

  pointer-events: none;
}


/* ============================================================
   CONTROL BASE
============================================================ */

.control-indicator {
  width: 16px;
  height: 16px;

  flex:
    0
    0
    16px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  margin-top: 0;

  color: #ffffff;

  background:
    #ffffff;

  border:
    1px solid
    rgba(65, 75, 90, 0.26);

  transition:
    background-color 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.18s ease;
}


/* ============================================================
   RADIO
============================================================ */

.radio-indicator {
  border-radius: 50%;
}


.radio-indicator::after {
  content: "";

  width: 6px;
  height: 6px;

  border-radius: 50%;

  background:
    #ffffff;

  transform:
    scale(0);

  transition:
    transform 0.18s ease;
}


/* ============================================================
   CHECKBOX
============================================================ */

.checkbox-indicator {
  border-radius: 5px;
}


.checkbox-indicator svg {
  width: 11px;
  height: 11px;

  opacity: 0;

  transform:
    scale(0.65);

  transition:
    opacity 0.15s ease,
    transform 0.18s ease;
}


/* ============================================================
   CHECKED
============================================================ */

.checkbox-option input:checked
+ .control-indicator {
  background:
    linear-gradient(
      135deg,
      #3b8ef5,
      #3474e5
    );

  border-color:
    #397fe8;

  box-shadow:
    0
    0
    0
    3px
    rgba(55, 127, 228, 0.09);
}


.checkbox-option input:checked
+ .radio-indicator::after {
  transform:
    scale(1);
}


.checkbox-option input:checked
+ .checkbox-indicator svg {
  opacity: 1;

  transform:
    scale(1);
}


.checkbox-option:has(input:checked)
.option-text {
  color: #3477d9;

  font-family:
    "Eastman-Medium",
    sans-serif;
}


/* ============================================================
   HOVER
============================================================ */

.checkbox-option:hover {
  color: #3978d5;
}


.checkbox-option:hover
.control-indicator {
  border-color:
    rgba(55, 125, 225, 0.48);

  transform:
    scale(1.04);
}


/* ============================================================
   SPECIFICS
============================================================ */

.specifics-list {
  display: flex;
  flex-direction: column;

  gap: 1px;
}


.checkbox-option.specificity {
  margin-bottom: 7px;
}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.filters-container {
  background:
    linear-gradient(
      145deg,
      #22242a 0%,
      #1d1f24 100%
    );

  border:
    1px solid
    rgba(255, 255, 255, 0.07);

  box-shadow:
    0
    16px
    40px
    rgba(0, 0, 0, 0.18);
}


html[data-theme="dark"]
.filters-title {
  color: #f0f1f3;
}


html[data-theme="dark"]
.filters-eyebrow {
  color: #747981;
}


html[data-theme="dark"]
.filter-label {
  color: #a0a5ae;
}


html[data-theme="dark"]
.checkbox-option {
  color: #969ca5;
}


html[data-theme="dark"]
.filter-divider {
  background:
    rgba(255, 255, 255, 0.055);
}


html[data-theme="dark"]
.control-indicator {
  background:
    rgba(255, 255, 255, 0.035);

  border-color:
    rgba(255, 255, 255, 0.14);
}


html[data-theme="dark"]
.checkbox-option:hover {
  color: #a8c6f2;
}


html[data-theme="dark"]
.checkbox-option:hover
.control-indicator {
  border-color:
    rgba(120, 170, 245, 0.40);
}


html[data-theme="dark"]
.checkbox-option input:checked
+ .control-indicator {
  background:
    linear-gradient(
      135deg,
      #5598ee,
      #467ddd
    );

  border-color:
    rgba(120, 175, 250, 0.82);

  box-shadow:
    0
    0
    0
    3px
    rgba(90, 145, 225, 0.10);
}


html[data-theme="dark"]
.checkbox-option:has(input:checked)
.option-text {
  color: #91b6ee;
}


/* ============================================================
   FOCUS
============================================================ */

.checkbox-option input:focus-visible
+ .control-indicator {
  outline:
    2px solid
    rgba(55, 125, 225, 0.28);

  outline-offset: 2px;
}


html[data-theme="dark"]
.checkbox-option input:focus-visible
+ .control-indicator {
  outline-color:
    rgba(120, 170, 245, 0.32);
}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 700px) {

  .filters-container {
    width: 100%;

    padding:
      20px
      18px;

    border-radius: 18px;
  }


  .filters-header {
    margin-bottom: 20px;
  }


  .checkbox-option {
    font-size: 11px;
  }


  .filter-label {
    font-size: 10px;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .checkbox-option,
  .control-indicator,
  .radio-indicator::after,
  .checkbox-indicator svg {
    transition: none;
  }

}

</style>